import { useEffect, useState } from 'react';

export function useLocalStorage(key, initialValue) {
    return useStorage(key, initialValue, window.localStorage);
}

export function useSessionStorage(key, initialValue) {
    return useStorage(key, initialValue, window.sessionStorage);
}

function useStorage(key, initialValue, storage) {
    const [value, setValue] = useState(() => {
        const item = storage.getItem(key);

        if (item === null) {
            storage.setItem(key, JSON.stringify(initialValue));
            return initialValue;
        }

        try {
            return JSON.parse(item);
        } catch {
            return initialValue;
        }
    });

    useEffect(() => {
        if (value === undefined) {
            storage.removeItem(key);
        } else {
            storage.setItem(key, JSON.stringify(value));
        }
    }, [key, value, storage]);

    return [value, setValue];
}
